import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography } from '@material-ui/core';
import * as Actions from './../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    root: {}
});

class EventGradeList extends Component {
    componentWillMount = () => {
        const auth_id = this.props.auth.user.data.auth_id;

        this.props.getEventsNotGraded(auth_id);
    }

    handleRowClick = (event_id) => {
        this.props.history.push(`/grade/student/list/${event_id}`);
    }

    render() {
        const { eventNotGradedList, classes } = this.props;

        if (eventNotGradedList.length === 0) {
            return (
                <React.Fragment>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" color="inherit">
                                Course Grading
                        </Typography>
                        </Toolbar>
                    </AppBar>
                    No Items to Grade!
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">
                            Course Grading
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Course</TableCell>
                            {/* <TableCell>Lesson</TableCell> */}
                            <TableCell>Event</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Progress</TableCell>
                            <TableCell>Grade</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {eventNotGradedList.map((event_info, i) => {
                            return (
                                <TableRow key={event_info.company_calendar_event_id + '_' + i}>
                                    <TableCell>{event_info.CourseName}</TableCell>
                                    {/* <TableCell>{event_info.LessonName}</TableCell> */}
                                    <TableCell>{event_info.EventName}</TableCell>
                                    <TableCell>{event_info.EventDate}</TableCell>
                                    <TableCell>{event_info.gradedCount + "/" + event_info.StudentCount}</TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick(event_info.company_calendar_event_id);
                                            }}
                                        >
                                            <Icon>assignment</Icon>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEventsNotGraded: Actions.getEventsNotGraded
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        eventNotGradedList: dashboardApp.widgets.eventNotGradedList,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EventGradeList)));




// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/EventGradeList.js